module.exports = __webpack_public_path__ + "img/icon-done.b62f4359.svg";